import React, { useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import nabeel from '../assets/nabeel4.png';
import Email from '@material-ui/icons/Email';
import Password from '@material-ui/icons/Lock';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { signInUser, resetPassword } from '../redux/actions/auth.js';
import { useDispatch } from 'react-redux';
import Cross from '@material-ui/icons/Close';

const Signin = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [resetPassowrdModel, setModel] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('الايميل غير صالح').required('حقل الايميل مطلوب'),
    password: Yup.string()
      .min(6, 'يجب ان يكون الباسورد 6 احرف على الاقل')
      .required('حقل الباسورد مطلوب'),
  });
  const {
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    values,
    errors,
  } = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema,
    onSubmit(values) {
      dispatch(signInUser(values, history));
    },
  });
  const forgotPassword = () => {
    setModel(!resetPassowrdModel);
  };
  const dispatchResetPassowrd = (email) => {
    dispatch(resetPassword(email));
    setModel(!resetPassowrdModel);
    alert('سوف تصلك رسالة قريبا');
  };
  // const loginError = useSelector(status => status.authReducer.loginError);
  return (
    <div className=' my-4 lg:p-4 lg-m-0 signup-bg text-gray-700 mb-10'>
      <div className='lg:w-1/2 mx-auto bg-white lg:bg-transparent'>
        <div
          className='lg:z-40  lg:shadow-lg bg-white
     lg:mt-24 mx-auto md:px-8 px-8 sm:px-12 sm:w-3/4 md:w-4/5 xl:w-4/6 mb-10 mt-10 lg:border lg:border-gray-500 
     lg:rounded-lg lg:bg-gray-100 md:px-24 lg:px-12 xl:px-16 lg:py-12 lg:clearfix'
        >
          <div className='hidden lg:block lg:flex lg:justify-end text-gray-800'>
            <p className='text-base pt-6 '>سجل الدخول بإستخدام حسابك الشخصي</p>
          </div>
          <div className='hidden lg:block lg:flex lg:justify-end'>
            <NavLink to='/sign-up' className='pt-4 md:text-sm n-blue'>
              قم بالتسجيل
            </NavLink>
            <p className='pt-4 pl-1 text-gray-800 md:text-sm'>
              ليس لديك حساب ؟
            </p>
          </div>
          <div className='flex justify-center pt-8 pb-16 lg:hidden '>
            <img src={nabeel} alt='Logo' />
          </div>
          <form className='px-2 mt-8' onSubmit={handleSubmit}>
            <div className=' lg:flex  lg:flex-col'>
              <label className='flex justify-end mb-2 md:mt-8   text-gray-800 md:text-sm '>
                <div className='flex items-center'>
                  البريد
                  <Email
                    alt='email icon block '
                    className='  ml-2'
                    fontSize='small'
                    color='primary'
                  />
                </div>
              </label>

              <input
                name='email'
                type='text'
                onChange={handleChange}
                onBlur={handleBlur}
                values={values.email}
                className=' justify-end w-full p-1 border-2 rounded-lg focus:outline-none text-black '
              />
              <p className='h-3 mb-4 text-red-400 font-normal  text-sm'>
                {(touched.email && errors.email) || null}
              </p>
              <label className='flex justify-end mt-4 mb-2  items-center text-gray-800 md:text-sm '>
                <div className='flex items-center'>
                  كلمة السر
                  <Password
                    className=' ml-2'
                    style={{ fontSize: 22 }}
                    color='primary'
                    alt='Password icon'
                  />
                </div>
              </label>

              <input
                name='password'
                type='password'
                onChange={handleChange}
                onBlur={handleBlur}
                values={values.password}
                className='flex justify-end w-full p-1  border-2 rounded-lg focus:outline-none text-black '
              />

              <p className='h-3 mb-4 text-red-400 font-normal text-left'>
                {(touched.password && errors.password) || null}
              </p>

              <span
                onClick={() => forgotPassword(values.email)}
                className='mb-8 text-sm text-left cursor-pointer'
              >
                هل نسيت كلمه السر ؟
              </span>
              <div className='flex justify-center lg:mt-8 mt-12 mb-8 lg:mb-8'>
                <button
                  name='submit'
                  type='submit'
                  className='blue-bg  border justify-center text-white rounded-lg px-4 py-2 focus:outline-none'
                >
                  تسجيل الدخول
                </button>
              </div>
            </div>
          </form>
          <div className='flex justify-center text-sm pb-4 lg:hidden mb-24 lg:mb-8'>
            <NavLink to='/' className='pt-4 md:text-xs n-blue'>
              قم بالتسجيل
            </NavLink>
            <p className='pt-4 pl-1 text-gray-800 md:text-xs'>
              ليس لديك حساب ؟
            </p>
          </div>
        </div>
        {/* the forget password model goes here */}
        <div
          className={`w-full h-full bg-model fixed top-0 left-0 justify-center items-center z-40 ${
            resetPassowrdModel ? 'flex' : 'hidden'
          }`}
        >
          <div className='  md:w-2/4 md:h-75 model-res bg-white md:rounded-lg p-4 md:relative'>
            <div className=' flex justify-end model-p'>
              <div onClick={() => setModel(!resetPassowrdModel)}>
                <Cross alt='Exit' />
              </div>
            </div>
            <p className='text-right text-xs pb-6'>
              اكتب بريدك الالكتروني لتصلك رسالة لتغير الرمز السري
            </p>
            <h4 className='text-right pb-3'> البريد الالكتروني </h4>
            <div className='flex justify-end '>
              <input
                type='text'
                name='resetEmail'
                value={resetEmail}
                onChange={(e) => {
                  setResetEmail(e.target.value);
                }}
                className='bg-gray-100 p-1 outline-none border-b-4 w-full h-8 text-black'
              />
            </div>

            <div className='flex justify-center p-8'>
              <button
                onClick={() => dispatchResetPassowrd(resetEmail)}
                className='blue-bg border text-white rounded-lg p-1 w-24 focus:outline-none'
              >
                ارسال
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Signin;
